import { BRAIN_SEARCH_MESSAGES_PER_LOAD } from "@/brain-search/internal/BrainSearchMessageList"
import BrainSearchPageContent from "@/brain-search/internal/BrainSearchPageContent"
import { BrainSearchPageQuery } from "@/brain-search/internal/__generated__/BrainSearchPageQuery.graphql"
import { useGlobalDrawer } from "@/core/context/GlobalDrawerProvider"
import Relay from "@/relay/relayUtils"
import { DiscoSpinner } from "@disco-ui"
import { useEffect } from "react"
import { useLazyLoadQuery } from "react-relay"
import { graphql } from "relay-runtime"

function BrainSearchPage() {
  const drawer = useGlobalDrawer("brainSearch")

  const { node } = useLazyLoadQuery<BrainSearchPageQuery>(
    graphql`
      query BrainSearchPageQuery($brainSearchId: ID!, $first: Int!, $after: String) {
        node(id: $brainSearchId) {
          ... on BrainSearch {
            __typename
            id
            ...BrainSearchPageContentFragment @arguments(first: $first, after: $after)
          }
        }
      }
    `,
    {
      brainSearchId: drawer.params.convId || "",
      first: BRAIN_SEARCH_MESSAGES_PER_LOAD,
      after: null,
    },
    { fetchPolicy: "network-only" }
  )

  const brainSearch = Relay.narrowNodeType(node, "BrainSearch")

  // If the conversation no longer exists, go to the new conversation page
  useEffect(() => {
    if (!brainSearch) drawer.setParams({ convId: undefined })
  }, [drawer, brainSearch])
  if (!brainSearch) return null

  return <BrainSearchPageContent brainSearchKey={brainSearch} />
}

export default Relay.withSkeleton({
  component: BrainSearchPage,
  skeleton: () => <DiscoSpinner size={"lg"} absoluteCenter />,
})
